<div class="content">
  <div class="description">
    {{ 'AUTOMATIONS.EDITOR.TASKS.LOOKUP_CONTACT.DESCRIPTION' | translate }}
  </div>
  <div class="search-fields">
    {{ 'AUTOMATIONS.EDITOR.TASKS.LOOKUP_CONTACT.SEARCH_FIELDS' | translate }}
  </div>
  <ng-container *ngIf="components$ | async as components">
    <div class="inputs" *ngFor="let formControl of formArray.controls; let i = index; let last = last">
      <automata-data-entry
        [comparisons]="comparisons"
        [dataEntryOptions]="components"
        [formControl]="formControl"
        (remove)="removeDataEntryComponent(i)"
      ></automata-data-entry>
      <div class="and-label" *ngIf="!last">
        <mat-button-toggle-group [(value)]="joinType">
          <mat-button-toggle [value]="'AND'">And</mat-button-toggle>
          <mat-button-toggle [value]="'OR'">Or</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </ng-container>

  <button mat-button color="primary" (click)="addDataEntryComponent()">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_COMPANY.ADD_ADDITIONAL_FIELDS' | translate }}
  </button>
</div>
